/** Каталог якорей модуля «Персонал» */
export const STAFF_ANCHORS = {
  /** Шестерёнка настроек модуля у пункта «Персонал» в боковом меню */
  nav: {
    settings: 'staff.nav.settings',
  },
  table: {
    add: 'staff.table.add',
    statistics: 'staff.table.statistics',
    structure: 'staff.table.structure',
    settings: 'staff.table.settings',
    search: 'staff.table.search',
    resetFilters: 'staff.table.resetFilters',
    hideInactive: 'staff.table.hideInactive',
    /* Кнопки панели действий со списком — у каждой своё право, поэтому и шаг у каждой свой */
    bulkRoles: 'staff.table.bulkRoles',
    bulkBlock: 'staff.table.bulkBlock',
    bulkRestore: 'staff.table.bulkRestore',
    bulkExport: 'staff.table.bulkExport',
    /** Префикс якоря значка фильтра в заголовке колонки, дальше — ключ колонки из `headers` */
    filterPrefix: 'staff.table.filter.',
    filterFirst: 'staff.table.filter.role',
    filterLast: 'staff.table.filter.status',
    /** Без права просмотра сотрудников колонок «Роль», «Последний вход» и «Статус» нет — крайние фильтры другие */
    filterBasicFirst: 'staff.table.filter.position',
    filterBasicLast: 'staff.table.filter.department',
    rowMenu: 'staff.table.rowMenu',
    demoRow: 'staff.table.demoRow',
  },
  structure: {
    tree: 'staff.structure.tree',
  },
  /** Карточка сотрудника (EditEmployeeDialog) */
  edit: {
    personalFirst: 'staff.edit.personalFirst',
    personalLast: 'staff.edit.personalLast',
    structure: 'staff.edit.structure',
    roles: 'staff.edit.roles',
    signatures: 'staff.edit.signatures',
    save: 'staff.edit.save',
  },
  settings: {
    tabs: 'staff.settings.tabs',
    content: 'staff.settings.content',
  },
  activity: {
    profile: 'staff.activity.profile',
    edit: 'staff.activity.edit',
    analytics: 'staff.activity.analytics',
    actions: 'staff.activity.actions',
  },
} as const

/** Имена контекстов модуля */
export const STAFF_CONTEXTS = {
  table: 'staff.table',
  settings: 'staff.settings',
  activity: 'staff.activity',
} as const
